import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <section className="contact">
      <div className="contact-container">
        <h1 className="section-title">Contact</h1>
        <div className="contact-content">
          <div className="contact-info">
            <h2>Get In Touch</h2>
            <p>
              I'm always interested in hearing about new opportunities and exciting projects.
              Whether you have a question or just want to say hi, feel free to reach out!
            </p>
            <div className="contact-details">
              <div className="contact-item">
                <strong>Email:</strong> your.email@example.com
              </div>
              <div className="contact-item">
                <strong>LinkedIn:</strong> linkedin.com/in/yourprofile
              </div>
              <div className="contact-item">
                <strong>GitHub:</strong> github.com/yourusername
              </div>
              <div className="contact-item">
                <strong>Location:</strong> Your City, Country
              </div>
            </div>
          </div>
          <div className="contact-form">
            <h2>Send Me a Message</h2>
            <form className="form">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" rows={5} required></textarea>
              </div>
              <button type="submit" className="btn btn-primary">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;